import { AdminPanelLayout } from '@/features/adminPanel/components/AdminPanelLayout';
import { AgreementForm } from '@/features/agreements/components/AgreementForm';

const PAGE_TITLES = {
  create: 'Nuevo convenio',
  update: 'Editar convenio',
  view: 'Convenio',
};

export const AgreementPage = ({ action }) => {
  return (
    <AdminPanelLayout title={PAGE_TITLES[action] ?? 'Convenio'}>
      <AgreementForm action={action} />
    </AdminPanelLayout>
  );
};